module.exports = __webpack_public_path__ + "h5/img/support.a152eba6.png";